import { breakpoints, theme } from '@notino/react-styleguide';

import { css } from '@linaria/core';
import { styled } from '@linaria/react';
import { noScrollbarCss } from '@styles/common';

export const OverflowFadeWrapper = styled.div<{
  leftOverflow: boolean;
  rightOverflow: boolean;
  showOnlyOnDesktop?: boolean;
}>`
  position: relative;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    bottom: 0;
    left: -1px;
    width: 40px;
    z-index: ${({ leftOverflow }) => (leftOverflow ? 1 : -1)};
    opacity: ${({ leftOverflow }) => (leftOverflow ? 1 : 0)};
    transition: opacity 0.1s ease-in-out;
    background: linear-gradient(
      270deg,
      rgba(255, 255, 255, 0) 0%,
      rgba(255, 255, 255, 0.5) 20%,
      #ffffff 100%
    );

    display: ${({ showOnlyOnDesktop }) =>
      showOnlyOnDesktop ? 'none' : 'initial'};
    @media (min-width: ${breakpoints.md}) {
      display: initial;
    }
  }

  &::after {
    content: '';
    position: absolute;
    top: 0;
    bottom: 0;
    right: -1px;
    width: 40px;
    z-index: ${({ rightOverflow }) => (rightOverflow ? 1 : -1)};
    opacity: ${({ rightOverflow }) => (rightOverflow ? 1 : 0)};
    transition: opacity 0.1s ease-in-out;
    background: linear-gradient(
      90deg,
      rgba(255, 255, 255, 0) 0%,
      rgba(255, 255, 255, 0.5) 20%,
      #ffffff 100%
    );

    display: ${({ showOnlyOnDesktop }) =>
      showOnlyOnDesktop ? 'none' : 'initial'};
    @media (min-width: ${breakpoints.md}) {
      display: initial;
    }
  }
`;

export const ScrollableWrapper = styled.div`
  overflow: auto;
  width: 100%;
  ${noScrollbarCss}
`;

export const Arrow = styled.div<{
  position: 'left' | 'right';
  offset: string;
}>`
  cursor: pointer;
  position: absolute;
  display: none;
  align-items: center;
  justify-content: center;
  top: 50%;
  bottom: 0;
  z-index: 2;
  width: 1.75rem;
  height: 1.75rem;
  transform: translateY(-50%);

  left: ${({ position, offset }) => (position === 'left' ? offset : 'initial')};
  right: ${({ position, offset }) =>
    position === 'right' ? offset : 'initial'};

  @media (min-width: ${breakpoints.lg}) {
    display: flex;
  }
`;

export const circleArrowClass = css`
  height: 44px;
  min-width: 44px;
  border-radius: 50%;
  background-color: ${theme.color.background.primary};
  box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.15);
`;
